import { CardMedia, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { helpHttp } from "../../../helper/helpHttp";
import * as Styled from "./Course.styled";
import BackArrow from "../../../components/BackArrow";
import { useDispatch } from "react-redux";
import { changeLoading } from "../../../redux/slices/category";

export const Course = () => {
  const [courseId, setCourseId] = useState(null);
  const [modules, setModules] = useState([]);
  const { get } = helpHttp();
  const dispatch = useDispatch();

  useEffect(() => {
    if (courseId) {
      dispatch(changeLoading(true));

      get(`modulos/getModulosByCategoria/${courseId}`)
        .then((data) => {
          setModules(data.datos);
        })
        .catch(() => toast.error("Ha ocurrido un error"))
        .finally(() => {
          dispatch(changeLoading(false));
        });
    }
  }, [courseId]);

  useEffect(() => {
    const url = window.location.href;
    const id = url.split("/").at(-1);
    if (url && id) {
      setCourseId(id);
    }
  }, []);

  return (
    <>
      <BackArrow />
      <Styled.GridData>
        {modules?.length > 0 &&
          modules.map((element) => (
            <Styled.StyledCard estado={element.estado} key={element.id}>
              {element.estado === "habilitado" ? (
                <Link to={`${element.id}`}>
                  <CardMedia
                    component="img"
                    image={element.url_pdf}
                    alt={element.nombre}
                    className="enable"
                  />
                </Link>
              ) : (
                <>
                  <CardMedia
                    component="img"
                    image={element.url_pdf}
                    alt={element.nombre}
                  />
                </>
              )}
            </Styled.StyledCard>
          ))}
      </Styled.GridData>
    </>
  );
};
